import { memo, useEffect, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { analyticsActions, surveysActions } from '@actions';
import { splitSurveyGroups } from '@helpers/surveyFilters';
import { AnalyticsContainer } from '@features/Analytics/styles';
import ConversionTable from './ConversionTable';
import ConversionRates from './ConversionRates';
import ConversionTrend from './ConversionTrend';

const Conversion = memo(({ filter, filterVersion }) => {
    const lastFetchedVersion = useRef(-1);

    const language = useSelector(state => state.auth.user?.language);
    const { surveysTableData, qrTableData, total, conversionLoading, conversionTrendData } = useSelector(
        state => state.analytics,
    );
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(surveysActions.getAll());
    }, []);

    const currentQuery = useMemo(() => {
        return {
            locations: filter.locations.map(item => item.id),
            surveys: splitSurveyGroups(filter.surveys).surveys,
            from: filter.timeframe.start ? format(new Date(filter.timeframe.start), 'yyyy-MM-dd') : null,
            to: filter.timeframe.end ? format(new Date(filter.timeframe.end), 'yyyy-MM-dd') : null,
            grouping: filter.grouping,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    }, [filter]);

    useEffect(() => {
        if (filterVersion > lastFetchedVersion.current && filter.locations.length) {
            dispatch(analyticsActions.getAnalyticsConversion(currentQuery));
            lastFetchedVersion.current = filterVersion;
        }
    }, [filterVersion, currentQuery]);

    return (
        <AnalyticsContainer id="pl-content-analytics-conversion">
            <ConversionRates language={language} data={total} isLoading={conversionLoading} />
            <ConversionTrend data={conversionTrendData} language={language} grouping={filter.grouping} />
            <ConversionTable isLoading={conversionLoading} data={surveysTableData} filter={filter} type="surveys" />
            <ConversionTable isLoading={conversionLoading} data={qrTableData} filter={filter} type="qr" />
        </AnalyticsContainer>
    );
});

Conversion.displayName = 'Conversion';

export default Conversion;
